import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/store';
import { updateClinicalReviewDetails } from '../../../../../../services/CaseManagementService/caseManageSlice';

const ClinicalReviewCommentsField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateClinicalReviewDetails({
      comments: event.target.value
    }));
  };

  return (
    <TextField
      label="Additional Comments"
      multiline
      rows={2}
      fullWidth
      variant="outlined"
      value={currentCase?.clinicalReview?.comments || ''}
      onChange={handleChange}
      InputProps={{
        style: {
          alignItems: 'flex-start',
          padding: 0
        }
      }}
      inputProps={{
        style: {
          padding: '14px',
          minHeight: 'unset'
        }
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#ffffff'
        }
      }}
    />
  );
};

export default ClinicalReviewCommentsField;
